import { useMemo } from 'react';

import { useSearchState } from '#src/app/pages/search/shared/hooks';

type Result = ModelHookResult<{
	nOfFilters: number;
}>;

export function useAllFiltersMobileButton(): Result {
	const state = useSearchState();

	const nOfFilters = useMemo(() => {
		let count = state.topics.length;
		if (state.status !== 'all') count += 1;
		// one place, which can span several values ("London, England" and "London")
		if (state.locationCities.length) count += 1;
		count += state.locationCountries.length;
		return count;
	}, [state.topics, state.status, state.locationCities, state.locationCountries]);

	return {
		data: {
			nOfFilters,
		},
	};
}
